import {css} from 'lit';
export const styles = css`:host {
  --icon-border-radius: 6px;
  --icon-size: 50px;

  display: flex;
  align-items: center;
  color: var(--dark-text-secondary);
  border-radius: 4px;
}

xs-list-item-10 {
  padding: 0;
}

xs-list-item-10 strong {
    font-weight: 700;
  }

ef-icon {
  width: var(--icon-size);
  height: var(--icon-size);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  color: var(--dark-text);
  font-size: 1.857em;
  border-radius: var(--icon-border-radius);
  background-color: var(--gray-200);
}

strong {
  color: var(--dark-text);
  font-weight: 600;
}
`;
export default styles;
